import { Injectable } from '@angular/core';
import { ErrorService } from './error.service';

@Injectable({
    providedIn: 'root'
})
export class CameraService {

    constructor(public errorService: ErrorService) { }
    ngOnInit() {}
    fetchCameraAccessPermissions() {
        navigator.mediaDevices.getUserMedia({ audio: false, video: true })
            .then(function (stream) {
                if (stream.getVideoTracks().length > 0) {
                    //code for when none of the devices are available
                    console.log("code here for camera not available")
                    this.errorService.showCameraErrorAndGuidanceToEnableSettings()
                } else {
                    // code for when both devices are available
                    console.log("code here for camera available")
                }
            })
            .catch(function (error) {
                // code for when there is an error
                if(error.name == "NotAllowedError" ||  error.name == "NotFoundError" || error.name == "NotReadableError") {
                    this.errorService.showCameraErrorAndGuidanceToEnableSettings()
                }
            }.bind(this));
    }
}